// Packages
import { Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";

// Components
import StatusTag from "components/StatusTag";

// const
import { linkStatusTagDefinition, linkStatusLabelDefinition } from './main';

// Help
import { getRssiIcon } from '../helper';

export const getMainTableColumns = ({
  auth,
  columnHelper,
  permissions,
  theme,
  callbacks
}) => {
  return [
    // permissions && (permissions === "Admin" || permissions === "Super Admin") &&
    // CheckboxColumn(columnHelper, null, {
    //   getRowDisabled: (row, table) => {
    //     const selectedRows = table.getSelectedRowModel().rows;
    //     if (selectedRows.length === 0) return false;
    //     const lockedStatus = selectedRows[0].original.siteName;
    //     return row.siteName !== lockedStatus;
    //   },
    //   enableColumnPinning: false
    // }),
    columnHelper.accessor("status", {
      id: "status",
      header: "Status",
      // enableColumnPinning: true,
      cell: (info) => (
        <StatusTag
          status={info.getValue()}
          statusMapping={linkStatusTagDefinition}
          labelMapping={linkStatusLabelDefinition}
        />
      ),
    }),
    columnHelper.accessor(row => row.formattedName ?? "-", {
      id: "formattedName",
      header: "Client Name",
      cell: (info) => {
        const value = info.getValue();
        const client = info.row.original;
        const RssiIcon = getRssiIcon({ client });

        if (isEmpty(value)) return <Box>-</Box>

        return (
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-start", whiteSpace: "nowrap" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}><RssiIcon /></Box>
            <Box>{value}</Box>
          </Box>
        )
      },
    }),
    columnHelper.accessor(row => row.manufacturer ?? "-", {
      id: "manufacturer",
      header: "Manufacturer",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.ipAddress ?? "-", {
      id: "ipAddress",
      header: "IP Address",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.clientId ?? "-", {
      id: "clientId",
      header: "MAC Address",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.authenticationType ?? "_", {
      id: "authenticationType",
      header: "Authentication Type",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.connectedToDeviceName ?? "-", {
      id: "connectedToDeviceName",
      header: "Connected to",
      cell: (info) => {
        return (
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[2],
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={e => {
              const client = info.row.original;

              e.stopPropagation();
              callbacks?.handelConnectedTo && callbacks.handelConnectedTo(client);
            }}
          >
            {info.getValue()}
          </Typography>
        )
      },
    }),
    columnHelper.accessor(row => row.formattedInterface ?? "-", {
      id: "interface",
      header: "Interface",
      cell: (info) => {
        const value = info.getValue();
        if (isEmpty(value) || value === "-") return <Box>-</Box>;

        return (
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[2],
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={e => {
              const client = info.row.original;

              e.stopPropagation();
              callbacks?.handelInterface && callbacks.handelInterface(client);
            }}
          >
            {value}
          </Typography>
        )
      },
    }),
    columnHelper.accessor(row => row.vlan ?? "-", {
      id: "vlan",
      header: "VLAN",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.ssid ?? "-", {
      id: "ssid",
      header: "SSID",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.channel ?? "-", {
      id: "channel",
      header: "Channel",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedSignal ?? "-", {
      id: "formattedSignal",
      header: "Signal",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.snr ?? "-", {
      id: "snr",
      header: "SNR",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedDownload ?? "-", {
      id: "formattedDownload",
      header: "Download",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedUpload ?? "-", {
      id: "formattedUpload",
      header: "Upload",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedTraffic ?? "-", {
      id: "formattedTraffic",
      header: "Traffic (24HR)",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedLastSeen ?? "-", {
      id: "formattedLastSeen",
      header: "Last Seen",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedUpTime ?? "-", {
      id: "formattedUpTime",
      header: "Uptime",
      cell: (info) => <>{info.getValue()}</>,
    }),
  ].filter(Boolean);
}